export default __webpack_public_path__ + "static/media/04e_folded.b706859e.png";